import React from 'react';
import PlaylistForm from './PlaylistForm';

const PlaylistEdit = () => {
  return <PlaylistForm mode="edit" />;
};

export default PlaylistEdit;
